import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import AddRegisterAssignmentForm, { FormData } from "./AddRegisterAssignmentForm";
import { FormError } from "../models/FormError";
import { OrgUser } from "../models/OrgUser";
import { PermitTypeOrgRole } from "../models/PermitTypeOrgRole";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (orgUserIds: string[], permitTypeOrgRoleId: string) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  availableOrgUsers?: OrgUser[];
  availablePermitTypeOrgRoles?: PermitTypeOrgRole[];
}

const AddRegisterAssignmentModal = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  availableOrgUsers,
  availablePermitTypeOrgRoles,
}: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);
  const [formErrors, setFormErrors] = useState<FormError>({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setFormData({} as FormData);
    setFormErrors({} as FormError);
    setHasSubmitted(false);
  }, [open]);

  const validateFormData = (formData: FormData): FormError => {
    const formError: FormError = {};

    if (!formData.orgUserIds) {
      formError.orgUserIds = "Please select user";
    } else if (formData.orgUserIds.length < 1) {
      formError.orgUserIds = "Please select user";
    }

    if (!formData.permitTypeOrgRoleId) {
      formError.permitTypeOrgRoleId = "Please select user role";
    }

    return formError;
  };

  const handleSubmit = () => {
    setHasSubmitted(true);

    const validationErrors = validateFormData(formData);
    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const { orgUserIds, permitTypeOrgRoleId } = formData;
      onSubmit(orgUserIds, permitTypeOrgRoleId);
    }
  };

  const handleFormChange = (formData: FormData) => {
    if (hasSubmitted) {
      const validationErrors = validateFormData(formData);
      setFormErrors(validationErrors);
    }

    setFormData({ ...formData });
  };

  return (
    <Modal open={open} size="small">
      <Modal.Header>Add user to register</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <AddRegisterAssignmentForm
            users={availableOrgUsers}
            permitTypeOrgRoles={availablePermitTypeOrgRoles}
            formErrors={formErrors}
            errors={submitErrors}
            formData={formData}
            onChange={handleFormChange}
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Ok
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddRegisterAssignmentModal;
